import decimalFormatter from './decimalFormatter';


const getPriceValues = function getPriceValues(price) {
  const isRange = price.type === 'range';
  const minPrice = isRange ? price.min : price;
  const { sales, list } = minPrice;
  const retailPrice = list ? decimalFormatter(list.formatted) : decimalFormatter(sales.formatted);

  return {
    salesPriceDisplay: `${isRange ? 'From ' : ''}${decimalFormatter(sales.formatted)}`,
    retailPriceDisplay: isRange ? `From ${retailPrice}` : `${retailPrice} full price`,
    retailPriceValue: retailPrice,
    priceValue: list ? list.value : sales.value,
    salesPriceValue: sales.value,
  };
};

const getPriceStatus = function getPriceValues(price) {
  const isRange = price.type === 'range';
  const minPrice = isRange ? price.min : price;
  const { sales, list } = minPrice;
  const isFree = sales && sales.formatted === 'Free';
  const onSale = !isFree && list !== null;

  return { isFree, onSale };
};

const getRebateValues = function getRebateValues(rebatePrice) {
  if (rebatePrice) {
    const price = rebatePrice.type === 'range' ? rebatePrice.min.sales : rebatePrice.sales;

    const rebate = rebatePrice.type === 'range' ?
      `${decimalFormatter(rebatePrice.min.sales.formatted)} - ${decimalFormatter(rebatePrice.max.sales.formatted)}` :
      decimalFormatter(rebatePrice.sales.formatted);

    return {
      hasRebates: true,
      rebatePriceDisplay: `${rebate}`,
      rebatePriceValue: price.value,
    };
  }

  return { hasRebates: false, rebatePriceDisplay: '' };
};

const getAddOnValues = function getAddOnValues(addOns) {
  if (!addOns) {
    return null;
  }

  const addOnPriceDisplay = addOns.reduce((out, addOn) => {
    const { values } = addOn;

    if (values.minAddOnPrice === values.maxAddOnPrice) {
      out[addOn.id] = `${decimalFormatter(values.minAddOnPriceFormatted)}`;
    } else {
      out[addOn.id] = `${decimalFormatter(values.minAddOnPriceFormatted)} - ${decimalFormatter(values.maxAddOnPriceFormatted)}`;
    }

    return out;
  }, {});

  return {
    addOnPriceDisplay,
  };
};

export default function getPriceDisplay(price, rebatePrice, addOns) {
  return {
    ...getPriceValues(price),
    ...getPriceStatus(price),
    ...getRebateValues(rebatePrice),
    ...getAddOnValues(addOns),
  };
}
